// Поле выбора метрики фундаментального графика. В отличие от CompanySearch попап
// открывается сразу по клику/фокусу, а его содержимое (дерево категорий SelectColumnsTree)
// прорендерено сервером вместе со страницей — AJAX при открытии и вводе не нужен.
// Отдельного поля поиска в попапе нет: фильтрует это поле, той же логикой, что
// .treesearch в StaticTreeDialog (data-level='search' + скрытие строк по textContent).
// Навигацию по уровням (radio → категория, «назад») даёт сам StaticTreeDialog.
class MetricSearch extends Tango.Component {
	widgetDidMount() {
		const ctrl = document.getElementById(this.root);
		const popupid = this.root + '_popup';
		const popup = document.getElementById(popupid);
		if (!popup)
			return;
		const input = ctrl.querySelector('input');
		const tree = popup.querySelector("[data-ctrl='StaticTreeDialog']");
		if (!tree)
			return;
		var selectedItem = null;

		// Видимые в данный момент строки-ссылки: при фильтре — только совпавшие,
		// на уровне категории — её содержимое.
		const visibleItems = () =>
			Array.from(popup.querySelectorAll('.level-2 a')).filter(a => a.offsetParent != null);

		const clearSelection = () => {
			if (selectedItem) selectedItem.classList.remove('selected');
			selectedItem = null;
		};

		// Та же фильтрация, что у поиска в StaticTreeDialog: пустой запрос возвращает
		// дерево на первый уровень, непустой показывает все категории без заголовков
		// и прячет неподходящие строки.
		const applyFilter = () => {
			const q = input.value.trim().toLowerCase();
			clearSelection();

			if (!q) {
				tree.setAttribute('data-level', '1');
				tree.querySelectorAll('.level-2 tr').forEach(tr => tr.style.display = '');
				tree.querySelectorAll('.level-2').forEach(d => d.style.display = '');
				return;
			}

			tree.setAttribute('data-level', 'search');
			tree.querySelectorAll('.level-2').forEach(d => {
				var found = 0;
				d.querySelectorAll('tr').forEach(tr => {
					const match = (tr.textContent || '').toLowerCase().indexOf(q) >= 0;
					tr.style.display = match ? '' : 'none';
					if (match) found++;
				});
				d.style.display = found ? '' : 'none';
			});
		};

		input.addEventListener('input', applyFilter);

		attachContextMenu(ctrl, popupid, {
			triggerOn: 'keyup focus click',
			displayAround: 'triggerbottom',
			beforeOpen: function (data, event) {
				// Стрелки и Enter обрабатывает onKeyDown — не передёргивать открытый попап.
				if (event.keyCode == 38 || event.keyCode == 40 || event.keyCode == 13) return 2;
				return 0;
			},
			onOpen: function (data, event) {
				// Контент статический, но при пустом поле возвращаем дерево на первый
				// уровень: после прошлого визита оно могло остаться внутри категории.
				if (input.value.trim() == '') {
					tree.querySelectorAll('input[type=radio]').forEach(r => r.checked = false);
					applyFilter();
				}
				return Promise.resolve();
			},
			closeOnClick: true,
			// Закрываемся только по строке-ссылке (выбор метрики или lock): клики по
			// категории и «назад» ведут навигацию внутри попапа и закрывать его не должны.
			closeOnClickSelector: function (el) {
				const b = !!el.closest('a');
				if (b) input.value = '';
				return b;
			},
			closeOnScroll: false,
			closeOnResize: false
		});

		const onKeyDown = function (e) {
			const el = e.currentTarget;
			if (!el.classList.contains('iw-opened')) return;
			const items = visibleItems();
			if (e.keyCode == 13) {
				// click() прогоняет строку через те же обработчики, что и мышь
				// (PostBackLink с onclick), — см. комментарий в CompanySearch.
				if (selectedItem) selectedItem.click();
				e.preventDefault();
				return;
			}
			var x = 0;
			if (e.keyCode == 38)
				x = -1;
			else if (e.keyCode == 40)
				x = 1;
			else
				return;
			e.preventDefault();
			if (items.length == 0) return;
			var i = items.indexOf(selectedItem);
			i = i < 0 ? (x == 1 ? 0 : items.length - 1) : (i + x + items.length) % items.length;
			clearSelection();
			selectedItem = items[i];
			selectedItem.classList.add('selected');
			selectedItem.scrollIntoView({ block: 'nearest' });
		}

		ctrl.addEventListener('keydown', onKeyDown);
	}
}

Tango.registerComponent(MetricSearch);
